import axios from 'axios'

class GeneralTrustPilot extends HTMLElement {
  constructor() {
    super()


  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get('general-trustpilot') === undefined) {
  customElements.define('general-trustpilot', GeneralTrustPilot)
}
